export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-26-C-front-side-back-twist-WEB-THUMB-06a510edd8b9ea9d0425677af699957c.jpg";